import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
// enums
import ESeverityLevel from '@/cms/enums/ESeverityLevel';
// types
import TValidations from '@/cms/types/TValidations';


type TRMDRTextBox = {
    id:string;

    name: string;
    title?: string;
    rmdrRef?: any;
    
    value?: string;
    placeholder?: string;

    errors?: TValidations[]|null;
    isAutoFocus?: boolean;

    type?: string;

    onValueChanged?: (name:string, value?:string|null) => void;

    className?: string;
    inputClassName?: string;
    disabled?: boolean;

}


const RMDRTextBox = ( props:TRMDRTextBox ) => {
    
    const [validation, setValidation] = useState<any>(null);

    useEffect(
        () => {
            let __value = props.errors?.find((item:any) => item.propertyName === props.name);

            if ( __value ) { 
                let className = "";
                let inputClassName = "";

                if (__value.severity === ESeverityLevel.ERROR) {
                    className = "tw-bg-red-100 tw-rounded-t-none tw-text-red-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-red-100 tw-rounded-b-none tw-text-red-700 tw-rounded";
                }
                else if (__value.severity === ESeverityLevel.WARNING) {
                    className = "tw-bg-orange-100 tw-rounded-t-none tw-text-orange-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-orange-100 tw-rounded-b-none tw-text-orange-700 tw-rounded";
                }
                else if (__value.severity === ESeverityLevel.INFO) {
                    className = "tw-bg-blue-100 tw-rounded-t-none tw-text-blue-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-blue-100 tw-rounded-b-none tw-text-blue-700 tw-rounded";
                }

                setValidation({ ...__value, className, inputClassName }); 
            }

            if ( !__value && validation ) setValidation(null);
        }, [ props.errors ]
    )

    const valueChanged = ( event:any ) => {
        if ( validation !== null ) setValidation(null);
    }

    return (
        <div className={props.className}>
            {
                props.title && (<label>{props.title}</label>)
            }
            <input
                ref={props.rmdrRef}
                type={props.type}
                className={clsx(props.inputClassName,validation?.inputClassName)}
                id={props.id}
                name={props.name}
                placeholder={props.placeholder}
                disabled={props.disabled}
                defaultValue={props.value}
                autoFocus={props.isAutoFocus}
                onChange={valueChanged}
            />
            {
                validation && (
                    <div className={clsx(validation.className, "tw-text-left")}>{validation.errorMessage}</div>
                )
            }
        </div>
    )
}

RMDRTextBox.defaultProps = {
    title: undefined,
    rmdrRef: undefined,
    
    value: "",
    placeholder: "",

    errors: undefined,
    isAutoFocus: false,

    type: "text",

    onValueChanged: null,

    className: "form-group",
    inputClassName: "form-control",
    disabled: false,
}

export default RMDRTextBox;
export type {
    TRMDRTextBox
};
